export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00598.2f81ee75.png";